const FIRST_VIEWPORT_IMAGE_RETRY_DELAYS_MS = Object.freeze([100, 250, 500, 1000, 2000, 4000]);

export const nextFirstViewportImageRetryDelayMs = attempt => (
  Number.isSafeInteger(attempt) && attempt >= 0
    ? FIRST_VIEWPORT_IMAGE_RETRY_DELAYS_MS[attempt] ?? null
    : null
);
